import React from "react";

const CareOfStatusBadge = ({ status }) => {
  const normalizedStatus = (status || "").toString().toLowerCase();

  const getStatusConfig = (value) => {
    switch (value) {
      case "active":
        return {
          bgColor: "bg-green-100 dark:bg-green-900/20",
          textColor: "text-green-600 dark:text-green-400",
          label: "Active",
        };
      case "inactive":
        return {
          bgColor: "bg-yellow-100 dark:bg-yellow-900/20",
          textColor: "text-yellow-700 dark:text-yellow-300",
          label: "Inactive",
        };
      case "pending":
        return {
          bgColor: "bg-blue-100 dark:bg-blue-900/20",
          textColor: "text-blue-600 dark:text-blue-400",
          label: "Pending",
        };
      case "lost":
        return {
          bgColor: "bg-red-100 dark:bg-red-900/20",
          textColor: "text-red-600 dark:text-red-400",
          label: "Lost",
        };
      default:
        return {
          bgColor: "bg-gray-100 dark:bg-gray-900/20",
          textColor: "text-gray-600 dark:text-gray-400",
          label: value ? `${value.charAt(0).toUpperCase()}${value.slice(1)}` : "Unknown",
        };
    }
  };

  const config = getStatusConfig(normalizedStatus);

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.bgColor} ${config.textColor}`}
    >
      {config.label}
    </span>
  );
};

export default CareOfStatusBadge;
